import { reqGet, reqPost, reqPut, reqDelete } from './axiosFun';

// 分页查询微信好友
export const friendPage = (params) => { return reqGet("/friend/page", params) };

// 新增微信好友
export const friendInsert = (params) => { return reqPost("/friend/", params) };

// 修改微信好友
export const friendUpdate = (params) => { return reqPut("/friend/", params) };

// 删除微信好友
export const friendDelete = (params) => { return reqDelete("/friend/", params) };

// 查询微信好友详情
export const friendDetail = (params) => { return reqGet("/friend/detail", params) };



// WEBPACK FOOTER //
// ./src/api/friend.js